import { useState } from 'react';

import EnvironmentalImpact from './EnvironmentalImpact';
import QuietZoneForm from './QuietZoneForm';
import QuietZoneResults from './QuietZoneResults';
import Savings from './Savings';
import { Container, ResultsContainer } from './styles';
import useQuietZoneCalculator from './useQuietZoneCalculator';
import { connectLocation } from '../../location/LocationConnectors';

export const QuietZoneCalculator = connectLocation(({ locale }) => {
  const [formValues, setFormValues] = useState({
    projectLocation: '',
    projectSqFoot: '',
  });
  const { onChangeInput, resetForm, isFormValid, onCalculate, results } = useQuietZoneCalculator({
    formValues,
    setFormValues,
    locale,
  });
  const { projectLocation, projectSqFoot } = formValues;

  return (
    <Container>
      <QuietZoneForm
        projectLocation={projectLocation}
        projectSqFoot={projectSqFoot}
        onChange={onChangeInput}
        resetForm={resetForm}
        isFormValid={isFormValid}
        onCalculate={onCalculate}
      />
      <ResultsContainer>
        <QuietZoneResults results={results} />
        {results && (
          <>
            <Savings results={results} />
            <EnvironmentalImpact results={results} />
          </>
        )}
      </ResultsContainer>
    </Container>
  );
});
